import { Injectable } from '@angular/core';
import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';

/**
 * Flag to enable/disable calendar view order card changes for EMEA region
 * @see https://cemexpmo.atlassian.net/browse/CX015GO1811-7739
 */
@Injectable()
export class EmeaCalendarViewImprovementsFeature implements IFlagFeature {
  name: string = Features.EMEA_CALENDAR_VIEW_IMPROVEMENTS;

  public isEnabled(container?: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
